import React from "react";
import { useStaticQuery, graphql } from 'gatsby';
import "./coursesCard.scss"

interface offerLearningProps {
    image?: string;
    tittle?: string;
    description?: string;
    location?: string;
    modality?: string;
    duration?: number;
    createdAt?: any;
    categoriaMultimedia?: string;
    callToAction?(): void;
    mobileImage?:string;
}

const CoursesCard = (props: offerLearningProps) => {

    const icons = useStaticQuery(graphql`
        query MEDIAICONSCARD {
            iconTaller: allContentfulAsset(
                filter: { title: { eq: "iconTaller" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconMasterclass: allContentfulAsset(
                filter: { title: { eq: "iconMasterclass" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconCursos: allContentfulAsset(
                filter: { title: { eq: "iconCursos" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconLocation: allContentfulAsset(
                filter: {title: {eq: "iconLocation"}}
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconDuration: allContentfulAsset(
                filter: {title: {eq: "iconDuration"}}
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconModality: allContentfulAsset(
                filter: {title: {eq: "iconModality"}}
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
        }
    `);

    const { 
        image = "//images.ctfassets.net/203frbsx1z3n/u1JyIoEqw21tEo0AwDirt/5099f40075ab853699de9dfcda5ebd43/Banner_mobile_dark.jpg",
        mobileImage = "//images.ctfassets.net/203frbsx1z3n/u1JyIoEqw21tEo0AwDirt/5099f40075ab853699de9dfcda5ebd43/Banner_mobile_dark.jpg",
        tittle = "Mi primer empleo Universo de posibilidades",
        description = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin nec hendrerit ex. Aenean sed magna feugiat, venenatis purus non, feugiat felis. Praesent congue nisi sed sem venenatis iaculis. Fusce pretium feugiat metus, ac interdum sem feugiat sit amet. Suspendisse molestie ultricies magna, eget iaculis lorem lobortis eu. Vestibulum sit amet est aliquam, dignissim est quis, posuere est. Duis leo nunc, consequat non diam fermentum, molestie tristique nisi. Proin euismod feugiat lorem ac dapibus. Mauris tristique elementum cursus. Vivamus ac ex elit. Fusce rutrum quam massa. Suspendisse aliquam elementum tincidunt. Fusce egestas mollis lectus at posuere. Vivamus congue, lorem ut ultricies volutpat, sapien enim consectetur risus, sit amet ullamcorper augue mi ac lorem.", 
        categoriaMultimedia = "Talleres",
        location = "Oriente",
        duration = 20,
        modality = "Virtual",
    } = props;


    const iconTaller: string = icons.iconTaller.nodes[0].file.url || "";
    const iconMasterclass: string = icons.iconMasterclass.nodes[0].file.url || "";
    const iconCursos: string = icons.iconCursos.nodes[0].file.url || "";
    const iconDuration: string = icons.iconDuration.nodes[0].file.url || "";
    const iconLocation: string = icons.iconLocation.nodes[0].file.url || "";
    const iconModality: string = icons.iconModality.nodes[0].file.url || "";

    const switchIcons = (icon) => {
        switch (icon) {
            case "Taller":
                return iconTaller;
            case "Acompañamiento coach ":
                return iconMasterclass;
            case "MasterClass":
                return iconMasterclass;
            case "Curso":
                return iconCursos;
            default:
                return iconMasterclass;
        }
    };

    return (
        <>
            <div className="m-courses-card">
                <div  className="m-courses-card__img">
                    <img
                        src={window.innerWidth >= 768 ? image : mobileImage}
                        alt="imagen ilustrativa curso"
                    />
                    {(props.categoriaMultimedia === 'Curso' ) ? (
                        <span className="m-courses-card__tag">Válido para Subsidio al desempleo</span>
                    ) : (
                        null
                    )}
                </div>
                <div className="m-courses-card__label">
                    <img
                        className="m-courses-card__label-img"
                        src={switchIcons(categoriaMultimedia)}
                        alt="imagen ilustrativa curso"
                    />
                    <span className="m-courses-card__label-text">{categoriaMultimedia}</span>
                </div>
                <div className="m-courses-card__info-container">
                    <span className="m-courses-card__info-title">{tittle}</span>
                    {window.innerWidth >= 768 && 
                        <p className="m-courses-card__info-description">{description}</p>
                    }
                    <div className="m-courses-card__info-aux">
                        <img src={iconLocation} alt="Icono ubicación"/>
                        <span className="m-courses-card__info-text">{location}</span>
                    </div>
                    <div className="m-courses-card__info-aux">
                        <img src={iconDuration} alt="Icono duración"/>
                        <span className="m-courses-card__info-text">Duración: {duration} Hora{duration !== 1 && "s"}</span>
                    </div>
                    <div className="m-courses-card__info-aux">
                        <img src={iconModality} alt="Icono modalidad"/>
                        <span className="m-courses-card__info-text">Modalidad: {modality}</span>
                    </div>
                </div>
                <button className="m-courses-card__button" onClick={() => {props.callToAction && props.callToAction()}}>MÁS INFORMACIÓN</button>
            </div>
        </>
    );
};

export default CoursesCard;
